import {asyncState, PENDING, FULFILLED, REJECTED} from 'utils';

export const SELECT_OPTION = 'SELECT_OPTION';
export const REQ_GET_BOOKS = 'REQ_GET_BOOKS';
export const RES_GET_BOOKS_SUCCESS = 'RES_GET_BOOKS_SUCCESS';
export const RES_GET_BOOKS_FAILURE = 'RES_GET_BOOKS_FAILURE';
export const REQ_GET_NEXT_BOOKS = 'REQ_GET_NEXT_BOOKS';
export const RES_GET_NEXT_BOOKS_SUCCESS = 'RES_GET_NEXT_BOOKS_SUCCESS';
export const RES_GET_NEXT_BOOKS_FAILURE = 'RES_GET_NEXT_BOOKS_FAILURE';

export const selectOption = (option) => ({
  type: SELECT_OPTION,
  option,
});
export const reqGetBooks = (value) => ({
  type: REQ_GET_BOOKS,
  value,
});
export const resGetBooksSuccess = (books) => ({
  type: RES_GET_BOOKS_SUCCESS,
  books,
});
export const resGetBooksFailure = (err) => ({
  type: RES_GET_BOOKS_FAILURE,
  err,
});
export const reqGetNextBooks = (index) => ({
  type: REQ_GET_NEXT_BOOKS,
  index,
});
export const resGetNextBooksSuccess = (nextBooks) => ({
  type: RES_GET_NEXT_BOOKS_SUCCESS,
  nextBooks,
});
export const resGetNextBooksFailure = (err) => ({
  type: RES_GET_NEXT_BOOKS_FAILURE,
  err,
});

export const INITIAL_STATE = {
  option: 'partial',
  startIndex: 1,
  searchText: '',
  totalItems: 1,
  books: [],
  booksState: asyncState(),
  nextBooksState: asyncState(),
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SELECT_OPTION:
      return {
        ...state,
        option: action.option,
      };
    case REQ_GET_BOOKS:
      return {
        ...state,
        searchText: action.value,
        booksState: asyncState(PENDING),
      };
    case RES_GET_BOOKS_SUCCESS:
      return {
        ...state,
        totalItems: action.books.totalItems,
        books: action.books.items,
        booksState: asyncState(FULFILLED),
      };
    case RES_GET_BOOKS_FAILURE:
      return {
        ...state,
        booksState: asyncState(REJECTED),
      };
    case REQ_GET_NEXT_BOOKS:
      return {
        ...state,
        startIndex: action.index + 10,
        nextBooksState: asyncState(PENDING),
      };
    case RES_GET_NEXT_BOOKS_SUCCESS:
      const {items} = action.nextBooks;
      return {
        ...state,
        books: state.books.concat(items),
        nextBooksState: asyncState(FULFILLED),
      };
    case RES_GET_NEXT_BOOKS_FAILURE:
      return {
        nextBooksState: asyncState(REJECTED),
      };
    default:
      return state;
  }
};
